























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import { Family } from '@/interfaces/Models';

@Component
export default class SessionForm extends Vue {
  public family: any = null;

  public processing: boolean = false;

  public families: any[] = [];
  public familyName: any = null;
  public familyLoading: boolean = false;

  public children: any[] = [];
  public selectedChildren: any[] = [];

  public babysitter: any = null;

  public babysitters: any[] = [];
  public babysitterName: any = null;
  public babysitterLoading: boolean = false;

  public sessionState: string = '';

  public errors: any = {};

  public get sessionStates() {
    return [
      {
        text: this.$t('session-states.listed'),
        value: 'listed',
      },
      {
        text: this.$t('session-states.confirmed'),
        value: 'confirmed',
      },
      {
        text: this.$t('session-states.finished'),
        value: 'finished',
      },
    ];
  }

  public sessionType: number = 0;
  public sessionTypes: any[] = [];
  public typesLoading: boolean = true;

  public sessionStartsAt: any = '';
  public sessionEndsAt: any = '';

  public get textFieldPropStartsAt(): any {
    return {
      outlined: true,
      'error-messages': this.errors['session_starts_at'],
    };
  }
  public get textFieldPropEndsAt(): any {
    return {
      outlined: true,
      'error-messages': this.errors['session_ends_at'],
    };
  }

  public get endDatePickerProps(): any {
    if (this.sessionStartsAt) {
      return {
        min: this.$moment(this.sessionStartsAt).format('YYYY-MM-DD'),
      };
    }
    return {};
  }

  public startPickerDate: string = '';
  public endPickerDate: string = '';

  public get startDatePickerProps(): any {
    // Admins can enter past shifts (e.g. logging a shift the family forgot).
    return {};
  }

  public get startTimePickerProps(): any {
    return { ...this.timePickerProps };
  }

  public get endTimePickerProps(): any {
    const props: any = { ...this.timePickerProps };
    if (this.sessionStartsAt) {
      const start = this.$moment(this.sessionStartsAt);
      const endDate =
        this.endPickerDate ||
        (this.sessionEndsAt
          ? this.$moment(this.sessionEndsAt).format('YYYY-MM-DD')
          : null);
      if (endDate && start.isSame(this.$moment(endDate), 'day')) {
        props.min = start.format('HH:mm');
      }
    }
    return props;
  }

  public timePickerProps: any = { format: '24hr', useSeconds: false };
  public datePickerProps: any = {};

  public $refs!: {
    form: HTMLFormElement; // fix for this.$refs.form.valdiate(); TS error
    startDatetimePicker: any;
    endDatetimePicker: any;
  };

  public setFamilies(families: any): void {
    this.families = families;
  }

  public setBabysitters(babysitters: any): void {
    this.babysitters = babysitters;
  }

  public setTypes(types: any[]): void {
    this.sessionTypes = types;
  }

  public submit() {
    /* if (!this.$refs.form.validate()) return; */

    this.processing = true;

    let payload = this.getPayload();

    axios
      .post(api.path('v1.admin.sessions'), payload)
      .then((res) => {
        this.$toast.success(res.data.message);
        this.errors = {};
        this.$refs.form.reset();
      })
      .catch((error) => (this.errors = error.response.data.errors))
      .finally(() => (this.processing = false));
  }

  public getPayload(): any {
    return {
      family_id: this.family ? this.family.id : null,
      babysitter_id: this.babysitter?.id,
      children: this.selectedChildren.filter(
        (child) => child.child_id !== null,
      ),
      type_id: this.sessionType || null,
      state: this.sessionState ? this.sessionState : null,
      session_starts_at: this.sessionStartsAt
        ? this.$moment(this.sessionStartsAt).format('YYYY-MM-DD, HH:mm')
        : null,
      session_ends_at: this.sessionEndsAt
        ? this.$moment(this.sessionEndsAt).format('YYYY-MM-DD, HH:mm')
        : null,
    };
  }

  @Watch('sessionStartsAt')
  onSessionStartsAtChange(value: any): void {
    if (value) {
      this.sessionEndsAt = this.$moment(value)
        .add(1, 'hours')
        .toDate();
    }
  }

  @Watch('familyName')
  @Debounce(500)
  onFamilyNameChange(value: string): void {
    let params = {
      paginate: 'no',
      name: value,
    };
    this.familyLoading = true;

    if (value === null) {
      this.familyLoading = false;
      this.families = [];
      this.children = [];
      return;
    }

    axios.get(api.path('v1.admin.families'), { params: params }).then((res) => {
      this.familyLoading = false;
      this.families = res.data.data;
    });
  }

  @Watch('family')
  onSelectedFamily(value: any): void {
    if (!value?.children) return;

    this.children = value?.children;
    this.selectedChildren = this.children.map((child: any) => {
      return { child_id: null, pickup_required: false };
    });
  }

  @Watch('family')
  @Watch('babysitterName')
  @Debounce(500)
  onBabysitterNameChange(value: string): void {
    let params = {
      paginate: 'no',
      name: value,
      family: this.family?.id,
      potential_babysitter: false,
    };
    this.babysitterLoading = true;

    axios
      .get(api.path('v1.admin.babysitters'), { params: params })
      .then((res) => {
        this.babysitterLoading = false;
        this.babysitters = res.data.data;
      });
  }

  public loadTypes() {
    let params = {
      paginate: 'no',
    };
    axios
      .get(api.path('v1.admin.sessionTypes'), { params: params })
      .then((res) => this.setTypes(res.data.data))
      .catch((err) => console.log(err))
      .finally(() => (this.typesLoading = false));
  }

  public mounted() {
    this.loadTypes();
    this.$watch(
      () => this.$refs.startDatetimePicker?.date,
      (newDate: string) => {
        if (newDate) this.startPickerDate = newDate;
      },
    );
    this.$watch(
      () => this.$refs.endDatetimePicker?.date,
      (newDate: string) => {
        if (newDate) this.endPickerDate = newDate;
      },
    );
  }
}
